<div class="flex min-h-screen bg-[#09090B] bg-linear-to-r from-[#09090B] to-[#18181B] text-[#FAFAFA] max-w-full min-w-0">
  
  <app-sidebar class="hidden shrink-0 md:flex"></app-sidebar>
  
  <div 
    class="flex min-w-0 flex-1 flex-col transition-all duration-200 max-w-full min-h-0"
    [class.sidebar-expanded-ml]="!layoutService.isSidebarCollapsed()"
    [class.sidebar-collapsed-ml]="layoutService.isSidebarCollapsed()"
  >
    
    <app-header></app-header>

    <main
      class="min-w-0 flex-1 max-w-full p-4 pt-20 pb-4 transition-all duration-200 bg-[linear-gradient(135deg,#09090B,#18181B)]"
      [class.md:pr-[360px]]="layoutService.isFixedDrawerPaddingActive()"
    >
      <router-outlet></router-outlet>
    </main>

  </div>

  <app-toast></app-toast>
  <app-song-profile-preview-drawer
    #globalSongDrawer
    mode="fixed"
    (sidebarOpenChange)="onGlobalDrawerOpenChange($event)"
  />
  <app-album-profile-preview-drawer
    #globalAlbumDrawer
    mode="fixed"
    (sidebarOpenChange)="onGlobalAlbumDrawerOpenChange($event)"
    (songClick)="onAlbumTrackClick($event)"
  />
</div>
